import React from "react";
import Image from "next/image";
import styles from "./StudentLoanFinance.module.css";
import CustomiseCta from "../CustomiseCta/CustomiseCta";

interface ImageData {
  id: number;
  documentId: string;
  url: string;
  alternativeText?: string | null;
}

interface TitleDescription {
  id: number;
  title: string;
  description: string;
}

interface CardWithImage {
  id: number;
  title_description: TitleDescription;
  images: ImageData[];
  mobiles_images?: ImageData[] | null;
}

interface FundingCard {
  id: number;
  card_with_image: CardWithImage;
  cta?: any;
}

interface Props {
  data: FundingCard[];
  popUpData?: any;
}

const StudentLoanFinance: React.FC<Props> = ({ data, popUpData }) => {
  return (
    <div className={styles.financeLayout}>
      <div className="container">
        {data.map(({ id, card_with_image, cta }) => (
          <div key={id} className={styles.card}>
            {card_with_image?.images?.[0]?.url && (
              <Image
                src={card_with_image.images[0].url}
                alt={card_with_image.images[0]?.alternativeText || "Image"}
                title={card_with_image.images[0]?.alternativeText || "Image"}
                width={93}
                height={52}
                className={styles.ImageCard}
              />
            )}
            <div>
              <h2 className={styles.financeHeader}>
                {card_with_image?.title_description?.title}
              </h2>
              <div className={styles.financeDescription}>
                {card_with_image?.title_description?.description}
              </div>
            </div>
            <div className={styles.buttonContainer}>
              <CustomiseCta ctaData={cta} popupData={popUpData} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentLoanFinance;
